// UserPreferencePage.js
import React, { useState,useEffect } from 'react';
import './UserPreference.css';
import { useNavigate } from 'react-router-dom';
import { getPrevMonthStartDate,getPrevMonthEndDate } from './components/utils';

const UserPreference = () => {
    const navigate = useNavigate();

    const [customerStatus, setCustomerStatus] = useState('Status.Active');
    const [invoiceStatus, setInvoiceStatus] = useState('draft');
    const [startDate, setStartDate] = useState(getPrevMonthStartDate());
    const [endDate, setEndDate] = useState(getPrevMonthEndDate());
  
  
    useEffect(() => {
      // Load user preferences from localStorage if available
      const savedPreferences = localStorage.getItem('userPreferences');
      if (savedPreferences) {
        const { customerStatus, invoiceStatus, startDate, endDate } = JSON.parse(savedPreferences);
        setCustomerStatus(customerStatus);
        setInvoiceStatus(invoiceStatus);
        setStartDate(startDate);
        setEndDate(endDate);
      }
    }, []);
  
    const handleSavePreferences = () => {
      // Save user preferences to localStorage
      const preferences = {
        customerStatus,
        invoiceStatus,
        startDate,
        endDate,
      };
      localStorage.setItem('userPreferences', JSON.stringify(preferences));
  
      // Navigate back to /invoices
      navigate('/invoices');
    };
  
    const handleCancel = () => {
      // Navigate back to /invoices
      navigate('/invoices');
    };
    function handleClear() {
        // Clear localStorage and reset state variables
        localStorage.clear();
        setCustomerStatus('Status.Active');
        setInvoiceStatus('draft');
        setStartDate(getPrevMonthStartDate());
        setEndDate(getPrevMonthEndDate());
        alert('Preferences reset successfully!');
      };

  return (
    <div className="user-preference-page">
      <h2>User Preferences</h2>
      <form onSubmit={handleSavePreferences}>
        <div className="form-group">
          <label htmlFor="customerStatus">Customer Status:</label>
          <select
            id="customerStatus"
            value={customerStatus}
            onChange={(e) => setCustomerStatus(e.target.value)}
          >
            <option value="Status.Active">Active</option>
            <option value="Status.Inactive">Inactive</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="invoiceStatus">Invoice Status:</label>
          <select
            id="invoiceStatus"
            value={invoiceStatus}
            onChange={(e) => setInvoiceStatus(e.target.value)}
          >
            <option value="draft">Draft</option>
            <option value="sent">Sent</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="startDate">Invoice Start Date:</label>
          <input
            type="text"
            id="startDate"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label htmlFor="endDate">Invoice End Date:</label>
          <input
            type="text"
            id="endDate"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <div className="button-container">
          <button type="submit" className="save-button">Save Preferences</button>
          <button type="button" onClick={handleCancel} className="cancel-button">Cancel</button>
          <button type="button" onClick={handleClear}>Reset Preferences</button>
        </div>
      </form>
    </div>
  );
};

export default UserPreference;
